// imports
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import ProductFormulationSyrupTypeSelect from 'components/common/simpleSelectors/FormulationSyrupType';
// interfaces, constants, helpers
import { ProductFormulationSyrupTypeSelectorProps } from 'interfaces';

const ProductFormulationSyrupTypeSelector: FC<ProductFormulationSyrupTypeSelectorProps> = ({
  name,
  title,
  handleChange,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <ProductFormulationSyrupTypeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            error={Boolean(message)}
            helperText={message}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ProductFormulationSyrupTypeSelector;
